module.exports = __webpack_public_path__ + "static/iconCS-5e3ef24bef7183ae168e475bed1fffb4.png";